export default "__VITE_ASSET__BlZmtblx__"